const matchesRegNumber = (registrationNumber) => (element) =>
  element.car.registrationNumber === registrationNumber;

export const matchingCarInPreferences = (loggedIn, preferredCars, registrationNumber) => {
  if (loggedIn && preferredCars.length > 0) {
    return preferredCars.find(matchesRegNumber(registrationNumber));
  }
  return false;
};
